var _defs, _rect, _path, _path2, _path3, _path4, _path5;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgTemple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    "data-name": "Layer 1",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 512 512",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:none;}.cls-2{fill:#fa6a13;}.cls-3{fill:#fef4d0;}.cls-4{fill:#fedd47;}"))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    className: "cls-1",
    width: 512,
    height: 512
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M889,721.1a29.36,29.36,0,0,1-2.8,3.87c-10.37,10.45-20.81,20.84-31.2,31.28a42,42,0,0,0-3,3.75H731c-1-5-1.89-10.06-3.11-15q-7.33-29.75-14.85-59.44c-.28-1.11-.71-2.17-1.16-3.5H663c-6.61-26.34-13.18-52.49-19.77-78.74L682.59,564q-14.69-58.9-29.41-118H574.4L535.13,289.25c13.44-14,26.15-27.14,38.85-40.32l1,.19c.35,1.61.68,3.23,1.07,4.83q11.64,47.28,23.3,94.57c3.84,15.5,7.8,31,11.76,46.46,1,3.74,2.14,7.42,3.25,11.22h78.26C705.77,458.76,718.9,511.06,732.17,564H683c6.57,26.38,13,52.2,19.5,78.37h49c6.71,26.37,13.32,52.36,19.92,78.33H830c-28.24-113-56.37-225.56-84.2-336.93l16.05-16.6q44.26,177.18,88.42,354Z",
    transform: "translate(-455.6 -248)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M575,249.12l-1-.19c0-.31,0-.62,0-.93H850q0,.5,0,1H580.93C578.93,249,576.94,249.07,575,249.12Z",
    transform: "translate(-455.6 -248)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    className: "cls-4",
    d: "M575,249.12c2-.05,4-.14,6-.14H850c2.63,10.06,5.35,20.1,7.88,30.19q15.32,61.29,30.52,122.61a34.94,34.94,0,0,1,.54,4.38H811.12a13.43,13.43,0,0,0,0,2.63c1.76,7.05,3.51,14.09,5.37,21.11,1.42,5.37,3,10.7,4.49,16,2.8,11.58,5.52,23.17,8.41,34.72q17.22,68.88,34.52,137.74,12.29,49.13,24.44,98.29a39.64,39.64,0,0,1,.62,4.39H850.24q-44.18-176.85-88.42-354l-16.05,16.6c27.83,111.37,56,224,84.2,336.93H771.41c-6.6-26-13.21-52-19.92-78.33h-49c-6.51-26.17-12.93-52-19.5-78.37h49.18c-13.27-52.91-26.4-105.21-39.58-157.77H614.33c-1.11-3.8-2.29-7.48-3.25-11.22-4-15.48-7.92-31-11.76-46.46Q587.61,301.24,576,254C575.63,252.35,575.3,250.73,575,249.12ZM810.69,328c3.31,13.24,6.51,26,9.67,38.61h20c-5-19.91-9.86-39.34-14.65-58.43H628.66c1.59,6.89,3.07,13.33,4.57,19.82Z",
    transform: "translate(-455.6 -248)"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M821,446c-1.5-5.35-3.07-10.68-4.49-16-1.86-7-3.61-14.06-5.37-21.11a13.43,13.43,0,0,1,0-2.63h77.82a5.72,5.72,0,0,1-.79,1.73C875.58,420.48,863,433,850,446Z",
    transform: "translate(-455.6 -248)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M810.69,328H633.23c-1.5-6.49-3-12.93-4.57-19.82H825.72c4.79,19.09,9.66,38.52,14.65,58.43h-20C817.2,354,814,341.27,810.69,328Z",
    transform: "translate(-455.6 -248)"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTemple);
export default __webpack_public_path__ + "static/media/Temple.0e405ccbedc2343a3d9341a2cbf11498.svg";
export { ForwardRef as ReactComponent };